import React, { Component } from 'react';
import logger from '../../diagnostics/logging/logger';
import * as pbi from 'powerbi-client';
import axios from 'axios';
import { sessionId } from '../../api/session';
import { apiBaseUrl } from '../../config';
import { FixtureApi } from '../../api/fixtureApi';
import { authenticationService } from '_legacy/auth/AuthenticationService';
import { DATASET_LPG_VLGC, DATASET_TANKERS } from '_legacy/models/Datasets';
import {
    enableSpecialTankersReports,
    specialTankersReportGroupIds,
} from '../../config';
import store from 'store';
import { getPowerBiReportFilters } from './powerBiReportFilters';

export function encodeDataSetId(datasetId) {
    // Hide the datasetId.
    //
    const data = `DATASET=${datasetId}=STUFF`;
    return btoa(data);
}

export function decodeDataSetToken(token) {
    const data = atob(token);
    const parts = data.split('=');
    return parts[1];
}

class AdvancedAnalyticsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            advancedAnalyticsMaintainanceMessage: null,
        };
    }

    componentDidMount() {
        logger.trackPageView('Analytics');

        FixtureApi.getMaintainanceMessage('Fixture Analytics Maintenance').then(
            (results) => {
                if (results) {
                    this.setState({
                        advancedAnalyticsMaintainanceMessage: results,
                    });
                } else {
                    this.renderAnalytics();
                }
            }
        );
    }

    renderAnalytics() {
        const datasetIdValue = decodeDataSetToken(
            this.props.match.params.token
        );
        const datasetId = parseInt(datasetIdValue, 10);
        const groupId = store.getState()?.user?.group?.id;

        axios
            .get(
                `https://${apiBaseUrl}/EmbeddedPowerBI/EmbedToken?type=dashboard&datasetId=${datasetId}`,
                {
                    headers: {
                        authorization: encodeURIComponent(
                            authenticationService.getAccessToken()
                        ),
                        fortSessionId: sessionId,
                    },
                }
            )
            .then((response) => {
                let powerbi = new pbi.service.Service(
                    pbi.factories.hpmFactory,
                    pbi.factories.wpmpFactory,
                    pbi.factories.routerFactory
                );
                let embedConfig = {
                    type: 'report',
                    id: response.data.ReportId,
                    embedUrl: response.data.EmbedUrl,
                    tokenType: pbi.models.TokenType.Embed,
                    accessToken: response.data.EmbedToken.token,
                    settings: {
                        filterPaneEnabled: false,
                        navContentPaneEnabled: false,
                    },
                    filters: getPowerBiReportFilters({
                        datasetId,
                        groupId,
                        enableSpecialTankersReports,
                        specialTankersReportGroupIds,
                        datasetFilterTarget: {
                            table: 'Dataset',
                            column: 'DatasetId',
                        },
                        pbi,
                    }),
                };

                // LPG-VLGC specific powerbi report
                if (datasetId === DATASET_LPG_VLGC) {
                    embedConfig.pageName = '6c633624a338e2d3ce63';
                }

                document.getElementsByClassName(
                    'fixture-count-placeholder'
                )[0] &&
                    powerbi.embed(
                        document.getElementsByClassName(
                            'fixture-count-placeholder'
                        )[0],
                        embedConfig
                    );
            });
    }

    render() {
        return (
            <div
                style={{ height: '100%', width: '100%' }}
                className="fixture-count-placeholder"
            >
                {this.state.advancedAnalyticsMaintainanceMessage}
            </div>
        );
    }
}

export default AdvancedAnalyticsPage;
